/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-04-22 18:58:55
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-07-27 17:02:25
 * @FilePath: /unifyxp-v2-store-portal/src/pages/FileDetail/service.ts
 */
import _ from 'lodash';
import { useEffect, useState } from 'react';

import {
  resourceDetail,
  createTag,
  deleteResource,
  saveSource,
} from '@/src/request/mediaLibrary';
import { MediaFile } from '@/src/types/common/media';
import { msg } from 'src/tools/message';

function useService(uuid: string) {
  const [saved, setSaved] = useState(false);
  const [file, setFile] = useState<MediaFile>({} as MediaFile);
  const [copy, setCopy] = useState<MediaFile>({} as MediaFile);

  useEffect(() => {
    resourceDetail(uuid).then((res) => {
      if (res) {
        setFile(res);
        setCopy(res);
      }
    });
  }, []);

  const handleDeleteTag = (tag) => {
    const f = _.cloneDeep(file);
    let tags = Array.isArray(f.tags) ? f.tags : [];
    tags = tags.filter((t) => t.uuid !== tag.uuid);
    f.tags = tags;
    setFile(f);
  };

  const handleChangeOriginalName = (value) => {
    const f = _.cloneDeep(file);
    const extension = f.originalName
      ? f.originalName.substring(f.originalName.lastIndexOf('.'))
      : '';
    f.originalName = `${value}${extension}`;
    setFile(f);
  };

  const handleAddTag = async (value) => {
    const f = _.cloneDeep(file);
    const tags = Array.isArray(f.tags) ? f.tags : [];
    const res = await createTag({ name: value });
    if (tags.findIndex((tag) => tag.uuid === res.uuid) === -1) {
      tags.push(res);
    }
    f.tags = tags;
    setFile(f);
  };

  const handleDelete = async (uuid: string) => {
    if (uuid) {
      await deleteResource([uuid]);
      msg.success('Source has been deleted');
    }
  };

  const handleSubmit = async () => {
    await saveSource(file);
    setSaved(true);
    msg.success('Source has been updated');
  };

  return {
    file,
    saved,
    copy,
    handleDeleteTag,
    handleDelete,
    handleSubmit,
    handleChangeOriginalName,
    handleAddTag,
  };
}

export default useService;
